import React from 'react';
import { cx } from '../../utils/cx.js';
import IconChip from './IconChip';

/** Page title block: optional eyebrow and icon chip, title, subtitle, actions on the right. */
const PageHeader = ({ icon = null, iconTone = 'brand', eyebrow = null, title, subtitle = null, actions = null, className = '' }) => (
  <header className={cx('flex flex-wrap items-center gap-x-4 gap-y-3', className)}>
    {icon && <IconChip icon={icon} tone={iconTone} />}
    <div className="min-w-0 flex-1 text-left">
      {eyebrow && <p className="mb-0.5 text-[10px] font-bold uppercase tracking-wider text-gray-400 dark:text-gray-500">{eyebrow}</p>}
      <h1 className="truncate text-xl font-bold tracking-tight text-gray-900 dark:text-white">{title}</h1>
      {subtitle && <p className="mt-0.5 text-sm text-gray-500 dark:text-gray-400">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-shrink-0 flex-wrap items-center gap-2">{actions}</div>}
  </header>
);

export default PageHeader;
